import React from 'react';
import ForgotPasswordInitialization from "../../components/forgot-password-section/ForgotPasswordInitialization";

const ForgotPassword = (props) => (
    <ForgotPasswordInitialization {...props}/>
);

export default ForgotPassword;